import { Component, OnInit, ElementRef } from '@angular/core';
import { PageBase, RentalInfo } from 't4core';
import { LayoutService } from 'app-components';
import { NavigationService } from 'app-components';
import { ActiveRentalService } from 'app-components';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from '../../../../../projects/app-components/src/lib/Services/SnackbarService/snackbar.service';
import { AppIntegrationService } from 't4-app-integration';

@Component({
  selector: 'app-pickup-complete',
  templateUrl: './pickup-complete.component.html',
    styleUrls: ['./pickup-complete.component.css'],
    standalone: false
})
export class PickupCompleteComponent extends PageBase implements OnInit {
  public booking: RentalInfo;
  constructor(el: ElementRef, private aviationService: NavigationService, private rentalService: ActiveRentalService, private layoutService: LayoutService, private snackbarService: SnackbarService, private appService: AppIntegrationService) {
    super(el);
  }

  async ngOnInit(): Promise<void> {
    this.booking = await this.rentalService.getBooking();
    this.appService.refreshRentals("Started", this.booking.Id);
    this.Insights.logEvent("Pickup complete", { rentalId: (this.booking.Id + "") });
    if (this.rentalService.offerReceived) {
      this.showSnackbar();
      this.rentalService.offerReceived = false;
    }

    setTimeout(() => this.next(), 2500);
  }


  showSnackbar() {
    this.snackbarService.openSnackBar('New offer from: ' + this.booking.PickupLocation.Name, "MyPage/Campaigns");
  }


  private nextClicked: boolean = false;
  public async next() {
    if (this.nextClicked) return;
    this.nextClicked = true;
    this.aviationService.executeCommand("Next");
  }
}
